// Rider portrait for the dashboard, as a photo job (photos.ts): cached, redone only when the outfit, colour or level
// change. The rendering itself (three.js, the rider model) lives in portraitStudio.ts and loads on demand.
import { photoKey, type PhotoJob } from './photos.js';

const VERSION = 11;

/** Portrait job for the photo queue; the key covers everything visible in it. */
export function portraitPhoto(look: unknown, color: string, level: number): PhotoJob {
  return { key: photoKey('portrait', VERSION, look, color, level), run: async () => (await import('./portraitStudio.js')).render(look, color, level) };
}
